import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sms-services.help.how-to-add-sms-user', {
        url: '/how-to-add-sms-user',
        component: 'companySmsServicesHelpHowToAddSmsUser',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sms-services/help/how-to-add-sms-user/how-to-add-sms-user.state.js